// Prevent browser back/forward navigation when swiping horizontally inside Swiper sliders.
// macOS trackpad horizontal swipes trigger history navigation when a scroll container
// reaches its boundary — this intercepts those events within any .swiper element.
(function () {
  document.addEventListener('wheel', function (e) {
    if (!e.target.closest('.swiper, .brand-resources-swiper, .brand-tabbed-swiper, .brand-values-swiper')) return;
    // Only block when horizontal delta dominates (trackpad swipe gesture)
    if (Math.abs(e.deltaX) > Math.abs(e.deltaY) && e.deltaX !== 0) {
      e.preventDefault();
    }
  }, { passive: false });
})();
